import { render, staticRenderFns } from "./TypeOfInsulationFormField.vue?vue&type=template&id=0c4f0e6a"
import script from "./TypeOfInsulationFormField.vue?vue&type=script&lang=js"
export * from "./TypeOfInsulationFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports